<div class="language-levels" data-testid="language-levels">
  @if (editMode) {
    <div class="language-levels__header">
      @if (c2Count === 1) {
        <span class="language-levels__native-badge" data-testid="language-levels-native-badge">{{
          'personalData.languageLevels.nativeBadgeSingular' | translate
        }}</span>
      } @else if (c2Count > 1) {
        <span class="language-levels__native-badge" data-testid="language-levels-native-badge">{{
          'personalData.languageLevels.nativeBadgePlural' | translate: {count: c2Count}
        }}</span>
      }
      @if (groupErrorVisible && hasGroupError()) {
        <div class="language-levels__group-error" data-testid="language-levels-group-error" role="alert">
          {{ groupErrorKey | translate }}
        </div>
      }
    </div>

    @if (rows.length === 0) {
      @if (!groupErrorVisible) {
        <p class="language-levels__empty-hint">
          {{ 'personalData.languageLevels.emptyHint' | translate }}
        </p>
      }
    } @else {
      <div class="language-levels__columns" aria-hidden="true">
        <span class="language-levels__column-head">{{ 'personalData.languageLevels.columnLanguage' | translate }}</span>
        <span class="language-levels__column-head">{{ 'personalData.languageLevels.columnLevel' | translate }}</span>
        <span></span>
      </div>
    }

    @for (row of rows.controls; track row; let i = $index) {
      <div
        class="language-levels__row"
        data-testid="language-levels-row"
        [attr.data-language]="row.get('language')?.value?.code"
        [attr.data-level]="row.get('level')?.value?.code"
        [formGroup]="row"
      >
        <div class="language-levels__field">
          <span class="language-levels__cell-label" aria-hidden="true">{{
            'personalData.languageLevels.columnLanguage' | translate
          }}</span>
          <app-ci-select
            #languageSelect
            class="language-levels__select"
            data-testid="language-levels-language"
            formControlName="language"
            [items]="languageOptions"
            [displayWith]="displayLanguage"
            [shrinkPanelToFit]="true"
            [compareWith]="compareLanguage"
            [isDisabled]="isLanguageDisabled(i)"
            [invalid]="
              row.get('language')?.invalid && row.get('language')?.touched
            "
            [errorText]="languageErrorKey(row) | translate"
            [ariaLabel]="languageFieldLabel(i)"
          ></app-ci-select>
        </div>
        <div class="language-levels__field">
          <span class="language-levels__cell-label" aria-hidden="true">{{
            'personalData.languageLevels.columnLevel' | translate
          }}</span>
          <app-ci-select
            #levelSelect
            class="language-levels__select"
            data-testid="language-levels-level"
            formControlName="level"
            [items]="levelOptions"
            [displayWith]="displayLevel"
            [shrinkPanelToFit]="true"
            [invalid]="row.get('level')?.invalid && row.get('level')?.touched"
            [errorText]="'personalData.languageLevels.errors.levelRequired' | translate"
            [ariaLabel]="levelFieldLabel(row, i)"
          ></app-ci-select>
        </div>
        <button
          mat-icon-button
          type="button"
          class="language-levels__remove-btn"
          data-testid="language-levels-remove"
          (click)="removeRow(i)"
          [attr.aria-label]="removeButtonLabel(row, i)"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    }

    @if (unknownCount > 0) {
      <div class="language-levels__legacy-hint">
        {{ 'personalData.languageLevels.legacyLanguageHint' | translate: {count: unknownCount} }}
      </div>
    }

    <div class="language-levels__footer">
      <button
        #addBtn
        type="button"
        class="language-levels__add-btn ci-request-button"
        data-testid="language-levels-add"
        (click)="addRow()"
      >
        <mat-icon>add</mat-icon>
        {{ 'personalData.languageLevels.addLanguage' | translate }}
      </button>
      @if (rows.length > 0) {
        <span class="language-levels__sort-hint">
          {{ 'personalData.languageLevels.sortHint' | translate }}
        </span>
      }
    </div>
  } @else {
    @if (rows.length === 0) {
      <p class="language-levels__empty">
        {{ 'personalData.unknown' | translate }}
      </p>
    }
    @for (row of rows.controls; track row; let i = $index) {
      @let lang = row.get('language')?.value;
      @let lvl = row.get('level')?.value;
      <div
        class="language-levels__read-row"
        data-testid="language-levels-read-row"
        [attr.data-language]="lang?.code"
        [attr.data-level]="lvl?.code"
      >
        <span [class.language-levels__lang--unknown]="lang?.unknown">{{ lang ? displayLanguage(lang) : '' }}</span>
        @if (lvl) {
          <span
            class="language-levels__level-badge"
            [class.language-levels__level-badge--native]="isNative(lvl)"
          >{{ displayLevel(lvl) }}</span>
        } @else {
          <span class="language-levels__missing-level">{{
            'personalData.languageLevels.missingLevel' | translate
          }}</span>
        }
      </div>
    }
  }
</div>
